// NotificationList helper functions and data
import { Notification } from "artisn/types";
import dayjs from "dayjs";

export const sortNotificationsByDate = (notificationList: Notification[]) => {
  const callback = (a: Notification, b: Notification) => {
    return (
      new Date(b.creationDate).getTime() - new Date(a.creationDate).getTime()
    );
  };
  return notificationList.sort(callback);
};

export const getDateOfNotifications = (
  notificationList: Notification[],
  dateFormat?: string
) => {
  const dates = notificationList.map(notification =>
    dayjs(notification.creationDate).format(dateFormat ?? "YYYY-MM-DD")
  );

  return dates;
};

export const getNotificationsByDate = (
  uniqueDates: string[],
  notificationsSortedByDate: Notification[]
) => {
  return uniqueDates?.map(date => {
    const notifications = notificationsSortedByDate?.filter(notification =>
      notification.creationDate.includes(date)
    );
    return notifications;
  });
};

export const getUnreadNotificationsId = (notifications: Notification[]) => {
  return notifications
    .filter(notification => notification.read === "NO")
    .map(notification => notification.id);
};
